module.exports = {"TXTMOB_Win_up_to_N0X":{"id":"TXTMOB_Win_up_to_N0X","defaultMessage":"Gewinne bis zu {0}!"}}